<div class="main-container">
  <div class="container">
    <div fxLayout="column" fxLayoutGap="40px" style="border:0px solid red">
      <div fxLayout="row wrap" fxLayoutAlign="space-between" style="border:0px solid red">
        <div style="border: 0px solid black">
          <h1 class="page-title">{{ 'PREPAYMENT_TITLE' | translate }}</h1>
          <p class="page-subtitle">{{ 'PREPAYMENT_SUBTITLE' | translate }}</p>
        </div>
        <div fxLayout="row" fxLayoutGap="10px" style="border: 0px solid blue">
          <div>
            <p class="page-subtitle">
              <b>{{ 'PAYMENTS_LEFT' | translate }}</b>: {{ paymentsLeft}}
            </p>
            <p class="page-subtitle">
              <b>{{ 'PAYMENTS_LEFT_EXPIRY_DATE' | translate }}</b>: {{ paymentsLeftExpiryDate | date:'dd/MM/yyyy' }}
            </p>
          </div>
          <div>
            <rezolve-primary-button (click)="refresh()">{{ 'REFRESH' | translate }}</rezolve-primary-button>
          </div>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="100px" style="border:0px solid red;">
        <div fxFlex="45%" fxFlex.lt-md="100%" style="border:0px solid red;">
          <ng-container *ngTemplateOutlet="tableTemplate"></ng-container>
        </div>
        <div fxFlex="30%" fxFlex.lt-md="100%" style="border: 1px solid black; height: 300px">
          <div *ngIf="!qrImgUrl" fxLayoutAlign="center">
            <p>QR Code</p>
          </div>
          <div *ngIf="qrImgUrl" fxLayout="column" fxLayoutAlign="center center" style="border: 0px solid black; ">
            <img [src]="qrImgUrl" height="250" width="250" style="border:0px solid red;"/>
            <h2 style=" border:0px solid red"><strong>{{ qrAmount | currency: 'MXN' }}</strong></h2>
          </div>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start" style="border:0px solid red">
        <div fxFlex="100%" style="border:0px solid red">
          <rezolve-base-table-2 [queryArray]="query" [tableColumns]="tableColumns" [dataSource]="dataSource" [defaultParams]="defaultParams"
                                [sortingEnabled]="true" [pageSizeOptions]="pageSizeOptions" [showInnerSpinner]="false">
          </rezolve-base-table-2>
        </div>
      </div>
    </div>
  </div>
  <div class="spinner-container" *ngIf="showSpinner"><mat-spinner></mat-spinner></div>
</div>



<!-- Define the packages offer table -->
<ng-template #tableTemplate>
  <table mat-table [dataSource]="packagesDataSource">
    <ng-container matColumnDef="payments">
      <th mat-header-cell *matHeaderCellDef> {{ 'NUMBER_OF_PAYMENTS' | translate }}</th>
      <td mat-cell *matCellDef="let element"> {{ element.payments }} </td>
    </ng-container>

    <ng-container matColumnDef="expiryDate">
      <th mat-header-cell *matHeaderCellDef> {{ 'EXPIRY_DATE' | translate }} </th>
      <td mat-cell *matCellDef="let element"> {{ element.expiryDate.toLocaleDateString()  }} </td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef> {{ 'PRICE' | translate }}</th>
      <td mat-cell *matCellDef="let element"> {{ element.price | currency: 'MXN' }} </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <rezolve-primary-button (click)="onBuy(element.packageId)">{{ 'BUY' | translate }}</rezolve-primary-button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</ng-template>
